let nextControlId = 0;

function uniqueId(prefix: string): string {
	nextControlId += 1;
	return `${prefix}-${nextControlId}`;
}

export interface LabeledRadio {
	radio: HTMLInputElement;
	label: HTMLLabelElement;
}

export interface LabeledCheckbox {
	checkbox: HTMLInputElement;
	label: HTMLLabelElement;
}

export interface LabeledSlider {
	slider: HTMLInputElement;
	label: HTMLLabelElement;
	row: HTMLDivElement;
}

export function createLabeledRadio(
	labelText: string,
	group: string,
	value: string,
	checked: boolean,
): LabeledRadio {
	const id = uniqueId(`radio-${group}`);

	const radio = document.createElement("input");
	radio.type = "radio";
	radio.name = group;
	radio.value = value;
	radio.checked = checked;
	radio.id = id;

	const label = document.createElement("label");
	label.textContent = labelText;
	label.htmlFor = id;

	return { radio, label };
}

export function createLabeledCheckbox(labelText: string, checked: boolean): LabeledCheckbox {
	const id = uniqueId("checkbox");

	const checkbox = document.createElement("input");
	checkbox.type = "checkbox";
	checkbox.checked = checked;
	checkbox.id = id;

	const label = document.createElement("label");
	label.textContent = labelText;
	label.htmlFor = id;

	return { checkbox, label };
}

export function createLabeledSlider(
	labelText: string,
	min: number,
	max: number,
	step: number,
	value: number,
): LabeledSlider {
	const id = uniqueId("slider");

	const slider = document.createElement("input");
	slider.type = "range";
	slider.min = String(min);
	slider.max = String(max);
	slider.step = String(step);
	slider.value = String(value);
	slider.id = id;
	slider.className = "slider";

	const label = document.createElement("label");
	label.textContent = labelText;
	label.htmlFor = id;

	const row = document.createElement("div");
	row.className = "form-row";
	row.appendChild(label);
	row.appendChild(slider);

	return { slider, label, row };
}
